// @flow
import styled, { css } from "styled-components";
import queryString from "query-string";
import { media } from "@nested/nested-react-components";
import { getImage } from "@nested/utils";
import { withNavColour } from "../../hocs/withNavColour/withNavColour";
import { StyledHero as Hero } from "../../components/StyledHero/StyledHero";

function generateBackgroundImageUrl(image, params) {
  const defaultParams = { h: 500, fit: "crop" };
  const imageUrl = getImage(
    `${image}?${queryString.stringify({ ...defaultParams, params })}`,
  );
  return css`
    background-image: url(${imageUrl});
  `;
}

const StyledHeroComponent = styled(Hero)`
  background-color: #555;
  background-position: center;
  position: relative;
  height: 500px;
  padding: 0;

  ${({ heroImage }) =>
    heroImage &&
    css`
      ${generateBackgroundImageUrl(heroImage, { w: 540 })};
      ${media.sm`
      ${generateBackgroundImageUrl(heroImage, { w: 768 })};
    `} ${media.md`
      ${generateBackgroundImageUrl(heroImage, { w: 992 })};
    `} ${media.lg`
      ${generateBackgroundImageUrl(heroImage, { w: 1200 })};
    `} ${media.xl`
      ${generateBackgroundImageUrl(heroImage)};
    `};
    `};
`;

export const StyledHero = withNavColour(StyledHeroComponent);
export const UniversalRender = StyledHero;
